import { ReviewStatus } from '@skop-app/lib-types'

export const OPTION_RETURNED_STATUS = 'RETURNED' as const
export const OPTION_DELETED_STATUS = 'DELETED' as const
export const OPTION_ARCHIVED_STATUS = 'ARCHIVED' as const

// ReviewStatus.REJECTED is still valid for review threads and legacy option
// records. Standard option validation refusals should use RETURNED; terminal
// option removals use DELETED; ARCHIVED keeps labels for existing usages.
export type OptionWorkflowStatus =
  | ReviewStatus
  | typeof OPTION_RETURNED_STATUS
  | typeof OPTION_ARCHIVED_STATUS
  | typeof OPTION_DELETED_STATUS

export const isOptionDraftStatus = (status?: string | null) =>
  status === ReviewStatus.PENDING || status === OPTION_RETURNED_STATUS

export const isOptionSelectableStatus = (status?: string | null) =>
  status !== ReviewStatus.REJECTED &&
  status !== OPTION_ARCHIVED_STATUS &&
  status !== OPTION_DELETED_STATUS

export const isOptionVisibleInConsumerStatus = (status?: string | null) =>
  status !== ReviewStatus.REJECTED && status !== OPTION_DELETED_STATUS
